var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"list-item-date"},[_c(_setup.ListItemText,{attrs:{"value":_setup.getDate}}),(_vm.isShowTime)?_c('span',[_c(_setup.ListItemText,{attrs:{"value":_setup.getTime,"color":"grey"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }